import { Button } from '@material-ui/core';
import React from 'react';
import { StoreSubscribe } from '../../../providers/global-store-provider';
import { Loader } from './helpers';

export default class ButtonWithStore extends React.Component {
    /*
    -----------------------------------------------------------------------
    RENDER Functions
    -----------------------------------------------------------------------
    */
    render() {
        const { action, color, variant, title, disabled, fullwidth, className,style, ...props } = this.props;
        return (
            <StoreSubscribe>
                {store => (
                    <Button
                        type="submit"
                        disabled={disabled}
                        variant={variant ? variant : "contained"}
                        color={color ? color : "primary"}
                        onClick={(e) => { e.preventDefault(); action(store); }}
                        fullWidth={fullwidth || false}
                        className={className || ''}
                        style={style || {}}
                    >
                        {disabled ? <Loader size={20} /> : (title ? title : "Save")}
                    </Button>
                )}
            </StoreSubscribe>
        );
    }
}